module.exports = __webpack_public_path__ + "debe49634e2c982beb25d25798b292d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/left-arrow.png
// module id = 218
// module chunks = 0